<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1APT7th/tc-custom/9780253010896.jpg?1724535441590" alt="This image is the cover for the book Jascha Heifetz, Russian Music Studies"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Jascha Heifetz, Russian Music Studies
      </h1>
      <p class="bookDescription body article font2">
        <p>Notoriously reticent about his early years, violinist Jascha Heifetz famously reduced the story of his childhood to "Born in Russia. First lessons at 3. Debut in Russia at 7. Debut in Carnegie Hall at 17. That's all there is to say." Tracing his little-known upbringing, Jascha Heifetz: Early Years in Russia uncovers the events and experiences that shaped one of the modern era's most unique talents and enigmatic personalities. Using previously unstudied archival materials and interviews with family and friends, this biography explores Heifetz's meteoric rise in the Russian music world—from his first violin lessons with his father, to his studies at the St. Petersburg Conservatory with the well-known pedagogue Leopold Auer, to his tours throughout Russia and Europe. Spotlighting Auer's close-knit circle of musicians, Galina Kopytova underscores the lives of artists in Russia's "Silver Age"—an explosion of artistic activity amid the rapid social and political changes of the early 20th century. </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Galina Kopytova, Dario Sarlo, Alexandra Sarlo
      </h2>
      
      <p class="authorDescription body article"><P>Galina Kopytova is a scholar and archivist specializing in the history of Russian musical culture. She heads the Office of Manuscripts of the Russian Institute for the History of the Arts in Saint Petersburg and is author of The Society for Jewish Folk Music in St. Petersburg-Petrograd (in Russian) and coauthor of From the History of Jewish Music in Russia (in Russian).</P><P>Translator Alexandra Sarlo has studied and conducted research in Russia, Slovakia, Serbia, and Ukraine.</P><P>Translator Dario Sarlo worked as a researcher on the documentary Jascha Heifetz: God's Fiddler by Peter Rosen Productions. He is a musicologist, violinist, and writer for The Strad.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Indiana University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2553f96c